export const API_BASE_URL = "https://api.kakeru.f5.si/atten";

const SESSION_ID_KEY = "testSessionId";
const defaultSessionId = "";

let sessionIdFromStorage = sessionStorage.getItem(SESSION_ID_KEY);

if (!sessionIdFromStorage) {
  const userInput = prompt("Enter test session id:", defaultSessionId);
  if (userInput) {
    sessionIdFromStorage = userInput;
    sessionStorage.setItem(SESSION_ID_KEY, sessionIdFromStorage);
  } else {
    sessionIdFromStorage = defaultSessionId;
  }
}

export const testSessionId = sessionIdFromStorage;
